import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "redux-query";
import { preview } from "common/constants";
import { ErrorType } from "components/widgets/base/common/errorTypes";
import { language } from "language/default";
import { datapointsKey } from "store/middleware/analytics/analytics-grouping-middleware";
export const isPostDatapointsFailedRequest = (action) => action.type === actionTypes.REQUEST_FAILURE &&
    action.queryKey?.startsWith(datapointsKey);
export const isPostDatapointsSucceesfulRequest = (action) => action.type === actionTypes.REQUEST_SUCCESS &&
    action.queryKey?.startsWith(datapointsKey);
const getError = (action, widgetIds) => {
    const BadRequest = 400;
    if (action?.responseText?.includes(ErrorType.EmptyCurrencyException)) {
        return ErrorType.EmptyCurrencyException;
    }
    if (action?.status === BadRequest && widgetIds.includes(preview.widgetId)) {
        const errors = Object.keys(action.responseBody?.errors || {});
        if (errors.includes("datapointPublicBenchmarkMeasureRule")) {
            const [message] = (action.responseBody?.errors?.datapointPublicBenchmarkMeasureRule || []);
            return message?.substring(0, message.indexOf(":"));
        }
        if (errors.includes("datapointClimateMeasureRule")) {
            const [message] = (action.responseBody?.errors?.datapointClimateMeasureRule || []);
            return message?.substring(0, message.indexOf(":"));
        }
    }
    return language.en.common.nodata;
};
const extractWidgetIds = (request) => request?.requests.map((c) => c.id.split(".", 2)?.[1]) || [];
const initialState = { widgetErrors: {} };
const slice = createSlice({
    extraReducers: (builder) => {
        builder
            .addMatcher((action) => isPostDatapointsFailedRequest(action), (state, action) => {
            const widgetIds = extractWidgetIds(action?.body);
            const error = getError(action, widgetIds);
            const errors = action?.responseBody?.errors?.requests?.map((c) => c.split(".", 2)?.[1]) || [];
            for (const id of errors.length === 0 ? widgetIds : errors) {
                state.widgetErrors[id] = error;
            }
        })
            .addMatcher((action) => isPostDatapointsSucceesfulRequest(action), (state, action) => {
            const widgetIds = extractWidgetIds(action?.body);
            for (const id of widgetIds) {
                delete state.widgetErrors[id];
            }
        });
    },
    initialState,
    name: "custom-errors",
    reducers: {}
});
export const customErrorsReducers = slice.reducer;
